import { ButtonTonal } from '@snack-uikit/button';
import { Card } from '@snack-uikit/card';
import { Typography } from '@snack-uikit/typography';
import cn from 'classnames';
import { useRouter } from 'next/navigation';
import { useTariffPlansState } from 'src/components/TariffPlans/tariff-plans-context';
import { TariffsProduct } from 'src/components/TariffPlans/types';
import { useAnalytics } from 'src/hooks/useAnalytics';

import s from './CalcCard.module.scss';
import { getAnalyticId } from './utils/getAnalyticId';
import { getCardTitle } from './utils/getCardTitle';
import { getProductToNavigate } from './utils/getProductToNavigate';

type CalcCardProps = {
  product: TariffsProduct;
  planIndex: number;
};

export function CalcCard({ product, planIndex }: CalcCardProps) {
  const router = useRouter();
  const state = useTariffPlansState();

  const isActive = state.activePlanIndex === planIndex;

  const cardClassName = cn(s.card, {
    [s.vm]: product === 'evolutionCloudServer',
    [s.s3]: product === 'evolutionStorageS3',
    [s.kuber]: product === 'evolutionKubernetes',
    [s.cardHovered]: isActive,
  });

  const analyticId = getAnalyticId(product);
  const { clickAnalytics } = useAnalytics();

  const handleButtonClick = (product: TariffsProduct) => {
    clickAnalytics({
      action: 'click',
      clickZone: 'body',
      clickElement: 'button',
      clickContent: 'В калькулятор',
      uniqueId: analyticId,
      transitionType: 'inside-link',
    });

    const totalProduct = getProductToNavigate(product);

    router.push('/calculator' + '?product=' + totalProduct);
  };

  return (
    <Card className={cardClassName}>
      <div className={s.content}>
        <Typography.SansTitleL className={s.title}>
          {getCardTitle(product)}
        </Typography.SansTitleL>
        <ButtonTonal
          size="m"
          className={s.button}
          label="Собрать"
          onClick={() => handleButtonClick(product)}
          appearance="neutral"
        />
      </div>
      <img
        src="/svg/components/Calculator/calculator.png"
        alt="calculator"
        className={s.img}
      />
    </Card>
  );
}
